
















































import { Component, Prop, Vue } from 'vue-property-decorator';
import { State } from 'vuex-class';
import { Button } from '@/pages/profile/components';
import { AppText } from '@/uikit';
import { DictionaryType } from '@/pages/professions/card/types';
import nameFromDictionary from '@/tools/nameFromDictionary';
import multiNameFromDictionary from '@/tools/multiNameFromDictionary';

@Component({
  components: {
    Button,
    AppText,
  },
})
export default class AddNewModuleCard extends Vue {
  @Prop({ type: Boolean, default: false })
  readonly readonly!: boolean;

  @Prop({ type: String, default: '' })
  readonly id!: string;

  @Prop({ type: String, default: '' })
  readonly title!: string;

  @Prop({ type: String, default: '' })
  readonly professionId!: string;

  @Prop({ type: String, default: '' })
  readonly formEducationId!: string;

  @Prop({ type: String, default: '' })
  readonly weeks!: string;

  @Prop({ type: String, default: '' })
  readonly studentCategories!: string;

  @Prop({ type: String, default: '' })
  readonly cost!: string;

  @Prop({ type: String, default: '' })
  readonly competences!: string;

  @State workTypes: DictionaryType;
  @State educationForm: DictionaryType;
  @State('competences') competencesList: DictionaryType;

  removeEmitId() {
    this.$emit('removeEmitId', this.id);
  }

  get linkParam() {
    const { id } = this;
    return { name: 'module', params: { id } };
  }

  get workType(): string {
    const { workTypes, professionId } = this;
    return professionId ? nameFromDictionary(workTypes, professionId) : '';
  }

  // get competencesType(): string {
  //   const { competences, competencesList } = this;
  //   return competences
  //     ? multiNameFromDictionary(competencesList, competences)
  //     : '';
  // }

  get educationFormType(): string {
    const { formEducationId, educationForm } = this;
    return formEducationId
      ? nameFromDictionary(educationForm, formEducationId)
      : '';
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/newprogram/components/cardlist/components/card/Card.vue